module.exports = __webpack_public_path__ + "static/img/15.994154d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/15.png
// module id = wOin
// module chunks = 0